/** The outlook opened over the page the player is on (the call sheet, the cockpit's full brief), so they do not lose their place. */
import { useEffect } from "react";
import type { ContentCatalog } from "@bsim/contracts";
import { useRoute, failureOf } from "../api/context";
import { Drawer } from "../theme/Drawer";
import { GxErrorBanner, GxWaiting } from "../theme/primitives";
import { OutlookBody } from "./OutlookBody";
import { OUTLOOK_NOTE } from "./OutlookPage";
import { markOutlookSeen, outlookRoundOf } from "./seen";

export function OutlookDrawer({ cohortId, catalog, onClose }: { readonly cohortId: string; readonly catalog: ContentCatalog; readonly onClose: () => void }) {
  const outlook = useRoute("marketOutlook", { cohortId });
  const round = outlook.data?.asOfRound;
  useEffect(() => { if (round !== undefined) markOutlookSeen(cohortId, outlookRoundOf(round)); }, [cohortId, round]); // the round being decided: the one the rail dot and the guide ask about
  return (
    <Drawer title={"Market outlook"} onClose={onClose}>
      <p className="gx-outlook-lead">{OUTLOOK_NOTE}</p>
      {outlook.error !== null ? <GxErrorBanner error={failureOf(outlook.error)} />
        : outlook.data === undefined ? <GxWaiting what="the market outlook" height={220} />
        : <OutlookBody outlook={outlook.data} catalog={catalog} narrow />}
    </Drawer>
  );
}
